var exports = {
  "zr": "x93eb46d8--471166--root",
  "Q": "x93eb46d8--471166--empty-content",
  "v9": "x93eb46d8--471166--offers-grid",
};

module.exports = exports;
